import React from 'react'
import './pleasantly-prices.scss'
import { Fade } from 'react-reveal'
import Image1 from '../../../assets/img/Project-Images/evefront.JPG'
import useFetch from '../../../Hooks/useFetch'

export default function PleasantlyPriced({ projectNumber }) {
  const { data } = useFetch()
  // console.log(data?.[0].Pleasantprice.card.title)
  return (
    <div id='pla-pri'>
      <img
        style={{ objectPosition: 'top' }}
        src={projectNumber?.fields.ppImg.fields.file.url}
        alt='azca title'
      />
      <Fade right>
        <div className='dark-card'>
          <div>
            <h2>{projectNumber?.fields.ppTitle}</h2>
            <p>{projectNumber?.fields.ppParagraph}</p>
          </div>
        </div>
      </Fade>
    </div>
  )
}
